import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bot } from 'lucide-react';

/**
 * Componente para mostrar estados de carga en el chat
 * @param {Object} props - Propiedades del componente
 * @param {string} props.message - Mensaje personalizado
 */
const ChatLoader = ({
  message = null
}) => {
  const { t } = useTranslation();

  // Renderizar animación de puntos (typing)
  const renderTypingDots = () => (
    <div className="chat-typing-dots">
      <div className="chat-typing-dot"></div>
      <div className="chat-typing-dot"></div>
      <div className="chat-typing-dot"></div>
    </div>
  );

  return (
    <div className="chat-loader">
      <div className="chat-loader-content">
        {/* Avatar del asistente */}
        <div className="chat-loader-avatar">
          <div className="chat-avatar chat-avatar--ai">
            <Bot size={16} />
          </div>
        </div>

        {/* Contenido del loader */}
        <div className="chat-loader-message">
          <div className="chat-loader-bubble">
            <div className="chat-loader-text">
              {message || t('chat.ai_escribiendo')}
            </div>
            <div className="chat-loader-animation">
              {renderTypingDots()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoader;
